var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 28.5V22C11 21.172 11.672 20.5 12.5 20.5H15.5C16.328 20.5 17 21.172 17 22V28.5M17 28.5H23V5.22667M17 28.5H27V14.8333M23 5.22667L25 4.5M23 5.22667L9 10.3187M27 14.8333L23 13.5M27 14.8333L29 15.5M3 28.5H5M5 28.5H29M5 28.5V4.5H9V10.3187M3 12.5L9 10.3187",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.990665268b44402e953a5322a36e9732.svg";
export { ForwardRef as ReactComponent };